// ============================================================================
// people.ts — КЛИЕНТСКАЯ защита «кто человек» для пикеров пользователей
// (исполнители задач/заявок, контакты, назначения).
//
// SSoT — сервер (people_only / SuggestAssignees уже отдают только людей).
// Этот модуль — вторая линия защиты: если сервер вернул служебную сущность
// (старая версия, спец-выборка по роли, другой адаптер), клиент её скроет.
//
// Служебные: системные учётные записи (is_system), боты/личности
// (is_bot / kind='bot'|'persona') и технические контакты транспортов
// (login tg_*, created_via='adapter').
// ============================================================================

export interface PersonLike {
  id?: string;
  login?: string;
  name?: string;
  kind?: string;
  isBot?: boolean;
  is_bot?: boolean;
  isSystem?: boolean;
  is_system?: boolean;
  createdVia?: string;
  created_via?: string;
}

/** Технический контакт транспорта (Telegram/MAX): логин tg_* или created_via='adapter'. */
export function isTechnicalContact(entity: PersonLike | null | undefined): boolean {
  if (!entity) return false;
  const login = String(entity.login ?? '').trim().toLowerCase();
  if (login.startsWith('tg_')) return true;
  const createdVia = String(entity.createdVia ?? entity.created_via ?? '').trim().toLowerCase();
  return createdVia === 'adapter';
}

/** Человек (не системная учётка, не бот/личность, не технический контакт). */
export function isPerson(entity: PersonLike | null | undefined): boolean {
  if (!entity) return false;
  if (entity.isSystem === true || entity.is_system === true) return false;
  if (entity.isBot === true || entity.is_bot === true) return false;
  const kind = String(entity.kind ?? '').trim().toLowerCase();
  if (kind === 'bot' || kind === 'persona') return false;
  return !isTechnicalContact(entity);
}

/** Отфильтровать список до людей (сохраняет порядок; null/undefined → []). */
export function filterPeople<T extends PersonLike>(items: readonly T[] | null | undefined): T[] {
  return (items || []).filter((item) => isPerson(item));
}
